var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 7.5,
    fill: "#FFF5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 7.5,
    stroke: "#C71F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0625 15.75H24.06L23.1525 14.76C22.8204 14.4334 22.3733 14.2503 21.9075 14.25H19.7175C19.2436 14.254 18.7906 14.4454 18.4575 14.7825L17.565 15.75H15.5625C15.2518 15.75 15 16.0018 15 16.3125C15 16.6232 15.2518 16.875 15.5625 16.875H26.0625C26.3732 16.875 26.625 16.6232 26.625 16.3125C26.625 16.0018 26.3732 15.75 26.0625 15.75ZM19.2675 15.555C19.3872 15.436 19.5487 15.3687 19.7175 15.3675H21.9075C22.0693 15.367 22.225 15.4288 22.3425 15.54L22.53 15.7425H19.095L19.2675 15.555Z",
    fill: "#C71F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1725 19.14V24.75C15.1725 26.5974 16.6701 28.095 18.5175 28.095H23.1075C24.9549 28.095 26.4525 26.5974 26.4525 24.75V19.14C26.4525 18.3116 25.7809 17.64 24.9525 17.64H16.7025C16.2995 17.6319 15.9102 17.7864 15.6224 18.0686C15.3346 18.3508 15.1724 18.7369 15.1725 19.14ZM19.125 21.7875C19.125 22.0982 18.8732 22.35 18.5625 22.35C18.2518 22.35 18 22.0982 18 21.7875V20.01C18 19.6993 18.2518 19.4475 18.5625 19.4475C18.8732 19.4475 19.125 19.6993 19.125 20.01V21.7875ZM20.8125 25.3125C21.1232 25.3125 21.375 25.0607 21.375 24.75V20.01C21.375 19.6993 21.1232 19.4475 20.8125 19.4475C20.5018 19.4475 20.25 19.6993 20.25 20.01V24.75C20.25 25.0607 20.5018 25.3125 20.8125 25.3125ZM23.625 21.7875C23.625 22.0982 23.3732 22.35 23.0625 22.35C22.7518 22.35 22.5 22.0982 22.5 21.7875V20.01C22.5 19.6993 22.7518 19.4475 23.0625 19.4475C23.3732 19.4475 23.625 19.6993 23.625 20.01V21.7875Z",
    fill: "#C71F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinButton);
export default __webpack_public_path__ + "static/media/binButton.341cdf23885e260134db86e8d6df961d.svg";
export { ForwardRef as ReactComponent };